const commonAndMisc = {
  errorMessage404: "Ôi! Trang bạn đang xem không tồn tại.", // translated 
  errorContentUnavailable:
    "Rất tiếc! Nội dung bạn đang tìm kiếm không tồn tại. Vui lòng liên hệ với chúng tôi để được hỗ trợ.", // translated 
  backToHome: "Trở về Trang chủ", // translated 
  information: "Thông tin", // translated 
  additionalInformation: "Thông tin bổ sung", // translated 
  destinationPlaceholder: "Bạn đi đâu vậy?", // translated 
  aboutUs: "Về chúng tôi", // translated 
  pleaseWait: "Vui lòng chờ...", // translated 
  featuredHotels: "Khách sạn nổi bật", // translated 
  topPackages: "Các gói hàng đầu", // translated 
  topTours: "Các tour du lịch hàng đầu", // translated 
  traveller: "Du khách", // translated 
  reviews: "Đánh giá", // translated 
  home: "Trang chủ", // translated 
  packages: "Gói hàng", // translated 
  experiences: "Trải nghiệm", // translated 
  close: "Đóng", // translated 
  loadingMessage: "Vui lòng chờ trong khi chúng tôi tìm kiếm mức giá tốt nhất hiện có.", // translated 
  loadingMessageTheHotelCo:
    "Vui lòng chờ trong khi chúng tôi tìm kiếm mức giá tốt nhất hiện có.", // translated 
  loadingMessageSearchStrip:
    "Vui lòng chờ trong khi chúng tôi tìm kiếm mức giá tốt nhất hiện có...", // translated 

  stillSearchingHotels:
    "Still searching — {{priced}} of {{discovered}} hotels priced",
  hotelsProgressCount: "Found {{priced}} of {{discovered}} hotels",
  searchingSuppliers: "Checking {{suppliers}}",
  topCountriesToVisit: "Những quốc gia hàng đầu nên ghé thăm", // translated 
  profile: "Hồ sơ", // translated 
  reservations: "Đặt chỗ", // translated 
  myBookings: "Đặt chỗ của tôi", // translated 
  address: "Địa chỉ", // translated 
  firstName: "Tên", // translated 
  lastName: "Họ", // translated 
  email: "E-mail", // translated 
  login: "Đăng nhập", // translated 
  logout: "Đăng xuất", // translated 
  myProfile: "Hồ sơ của tôi", // translated 
  myAccount: "Tài khoản của tôi", // translated 
  myPoints: "Điểm của tôi", // translated 
  myQuotations: "Những câu trích dẫn của tôi", // translated 
  myChatRooms: "Cuộc trò chuyện của tôi", // translated 
  chatRoomsListEmpty: "Tài khoản này của bạn không có phòng chat nào.", // translated 
  chatRoomsOpen: "Mở", // translated 
  chatRoomsLastActivity: "Hoạt động cuối cùng", // translated 
  chatRoomsUnread: "Chưa đọc", // translated 
  chatRoomsBadgeQuotation: "Trích dẫn", // translated 
  chatRoomsBadgeTripOffer: "Ưu đãi chuyến đi", // translated 
  chatRoomsOpenQuotationAria: "Mở cuộc trò chuyện báo giá: {{name}}", // translated 
  chatRoomsOpenTripOfferAria: "Mở kênh trò chuyện về đề nghị chuyến đi: {{name}}", // translated 
  chatRoomsOpenGenericAria: "Mở trò chuyện: {{name}}", // translated 
  quotationChatInvalidLink:
    "Liên kết trò chuyện không hợp lệ. Hãy mở cuộc trò chuyện từ hồ sơ hoặc danh sách báo giá của bạn, hoặc sử dụng chính xác một trong hai giá trị room_code hoặc room_uid.", // translated 
  quotationChatNoTripDetails: "Thông tin chi tiết về chuyến đi hiện không có sẵn trong cuộc trò chuyện này.", // translated 
  chat: "Trò chuyện", // translated 
  verified: "Đã xác minh", // translated 
  unverified: "Chưa được xác minh", // translated 
  selectLanguage: "Chọn ngôn ngữ", // translated 
  selectCurrency: "Chọn đơn vị tiền tệ", // translated 
  upgrade: "Nâng cấp", // translated 
  membership: "Thành viên", // translated 
  travelTrust: "Quỹ tín thác du lịch", // translated 
  signInUp: "Đăng nhập/Đăng ký", // translated 
  worldwideHotelsAndResortsAtAmazingWholesaleRates:
    "Khách sạn và khu nghỉ dưỡng trên toàn thế giới với giá bán buôn cực kỳ hấp dẫn", // translated 
  dashboard: "Bảng điều khiển", // translated 
  pricing: "Giá cả", // translated 
  refundable: "Có thể hoàn trả", // translated 
  cars: "Ô tô", // translated 
  cruises: "Du thuyền", // translated 
  view: "Xem", // translated 
  price: "Giá", // translated 
  totalPrice: "Tổng giá", // translated 
  filterRoomName: "Lọc theo tên phòng", // translated 
  get: "Lấy", // translated 
  guestInformationValidation: "Xác thực thông tin khách hàng", // translated 
  reservation: "Sự đặt chỗ", // translated 
  checkIn: "Đăng ký vào", // translated 
  checkOut: "Hãy xem", // translated 
  paymentInitiattionErroeMessage:
    "Chúng tôi không thể bắt đầu quá trình thanh toán của bạn. Chúng tôi xin lỗi vì sự bất tiện này.", // translated 
  warning: "Cảnh báo", // translated 
  couldNotFindPriceForDateWarning:
    "Chúng tôi không tìm thấy giá cho ngày này. Vui lòng thử lại với ngày khác.", // translated 
  searchFormValidationError: "Lỗi xác thực biểu mẫu tìm kiếm", // translated 
  pleaseSelectValidDateFirst: "Vui lòng chọn ngày hợp lệ trước", // translated 
  searchError: "Lỗi tìm kiếm", // translated 
  priceSearchInitiationError:
    "Chúng tôi không thể bắt đầu quá trình tìm kiếm giá. Vui lòng thử lại sau. Chúng tôi xin lỗi vì sự bất tiện này.", // translated 
  searchWarning: "Cảnh báo tìm kiếm", // translated 
  couldNotFindPriceAndOrAvailability:
    "Chúng tôi không tìm thấy giá cả và/hoặc thông tin về tình trạng hàng hóa cho yêu cầu của bạn. Chúng tôi xin lỗi vì sự bất tiện này.", // translated 
  joinNow: "Tham gia ngay", // translated 
  signIn: "Đăng nhập", // translated 
  searchNow: "Tìm kiếm ngay", // translated 
  bookingFailed: "Đặt chỗ thất bại", // translated 
  sorryForTheInconvenience: "Chúng tôi xin lỗi vì sự bất tiện này.", // translated 
  contactUsToAssistWithYourBooking:
    "Vui lòng liên hệ với chúng tôi để được hỗ trợ đặt chỗ. Chúng tôi xin lỗi vì sự bất tiện này.", // translated 
  paymentFailedTryAgain: "Giao dịch thanh toán không thành công. Vui lòng thử lại.", // translated 
  quickLinks: "Liên kết nhanh", // translated 
  tours: "Các tour du lịch", // translated 
  termsAndConditions: "Điều khoản và điều kiện", // translated 
  pleaseWaitWhileInitiatingPayment:
    "Vui lòng chờ trong khi chúng tôi bắt đầu quy trình thanh toán của bạn.", // translated 
  back: "Mặt sau", // translated 
  nextStep: "Bước tiếp theo", // translated 
  book: "Sách", // translated 
  checkout: "Thanh toán", // translated 
  specifyPickUpPoint: "Vui lòng chỉ định điểm đón khách mà bạn muốn.", // translated 
  pickupPoint: "Điểm đón", // translated 
  optional: "không bắt buộc", // translated 
  provideImportantInfoForYourTravel:
    "Hãy cho chúng tôi biết bất kỳ thông tin nào quan trọng đối với chuyến đi của bạn.", // translated 
  remarks: "Ghi chú", // translated 
  travellerInformation: "Thông tin dành cho du khách", // translated 
  bookingRemarks: "Ghi chú đặt phòng", // translated 
  bookingOverview: "Tổng quan về đặt chỗ", // translated 
  paymentFailed: "Thanh toán thất bại", // translated 
  paymentSuccess: "Thanh toán thành công", // translated 
  at: "Tại", // At date // translated 
  on: "TRÊN", // on date // translated 
  person: "người", // translated 
  cancellationPolicy: "Chính sách hủy bỏ", // translated 
  From: "Từ", // translated 
  to: "ĐẾN", // translated 
  cancellationIs: "việc hủy bỏ là", // translated 
  pickup: "Nhặt lên", // translated 
  flights: "Các chuyến bay", // translated 
  Accommodation: "Chỗ ở", // translated 
  payAndBook: "Thanh toán & Đặt chỗ", // translated 
  onRequest: "Theo yêu cầu", // translated 
  weAreFindingTheBestAvailableServices:
    "Chúng tôi đang tìm kiếm những dịch vụ tốt nhất hiện có.", // translated 
  withTheBestAvailablePrices: "với mức giá tốt nhất hiện có", // translated 
  inRealTime: "trong thời gian thực", // translated 
  seconds: "giây", // translated 
  thisProcessCanTakeUpToOneMinute: "Quá trình này có thể mất đến 1 phút.", // translated 
  pleaseDoNotRefreshThisPage: "Vui lòng không làm mới trang này.", // translated 
  wellItSeemsItCanTakeBitLonger: "Ừm... có vẻ như sẽ mất thêm chút thời gian.", // translated 
  yourBrowserDoesNotSupportTheVideoTag:
    "Trình duyệt của bạn không hỗ trợ thẻ video.", // translated 
  bookingSuccess: "Đặt chỗ thành công", // translated 
  bookingReference: "Mã đặt chỗ", // translated 
  referenceCopied: "Tài liệu tham khảo đã được sao chép", // translated 
  shortlyYouReceiveEmailContainingInformationForYourReservation:
    "Bạn sẽ sớm nhận được email chứa tất cả thông tin cần thiết cho việc đặt chỗ của mình.", // translated 
  viewMore: "Xem thêm", // translated 
  readMore: "Đọc thêm", // translated 
  customerSupport: "Hỗ trợ khách hàng", // translated 
  socialMedia: "Mạng xã hội", // translated 
  hours: "giờ", // translated 
  hour: "giờ", // translated 
  minutes: "phút", // translated 
  minute: "phút", // translated 
  memberId: "Mã thành viên", // translated 
  star: "Ngôi sao", // translated 
  stars: "Sao", // translated 
  proceed: "Tiếp tục", // translated 
  clearAllFilters: "Xóa tất cả bộ lọc", // translated 
  clearYourFilters: "Vui lòng xóa các tùy chọn bộ lọc để xem kết quả.", // translated 
  noOptionsForSelectedFilters: "Không có tùy chọn nào phù hợp với bộ lọc của bạn.", // translated 
  privacyPolicy: "Chính sách bảo mật", // translated 
  security: "Bảo vệ", // translated 
  nearby: "Gần đó", // translated 
  distanceFromSelection: "Khoảng cách từ điểm chọn", // translated 
  km: "km", // translated 
  restaurants: "Nhà hàng", // translated 
  active: "Tích cực", // translated 
  visitSite: "Truy cập trang web", // translated 
  score: "Điểm", // translated 
  applicationAvailable: "đơn đăng ký có sẵn", // translated 
  sendUsEmail: "Gửi email cho chúng tôi", // translated 
  sendUsYourRequest: "Hãy gửi yêu cầu của bạn cho chúng tôi.", // translated 
  notAvailable: "Không có sẵn", // translated 
  found: "Thành lập", // translated 
  progressAt: "Tiến độ tại", // translated 
  currency: "Tiền tệ", // translated 
  sendUsRequest: "Hãy gửi yêu cầu của bạn cho chúng tôi.", // translated 
  noReservationsForThisProduct: "Không có đặt chỗ trước cho sản phẩm này.", // translated 
  noBookingsForThisProduct: "Không nhận đặt chỗ cho sản phẩm này.", // translated 
  noReservationsOfThisProduct: "Không nhận đặt chỗ trước cho loại sản phẩm này.", // translated 
  actions: "Hành động", // translated 
  save: "Cứu", // translated 
  confirmed: "Đã xác nhận", // translated 
  cancelled: "Đã hủy", // translated 
  pending: "Chưa giải quyết", // translated 
  notConfirmed: "Chưa được xác nhận", // translated 
  status: "Trạng thái", // translated 
  reference: "Thẩm quyền giải quyết", // translated 
  leadGuest: "Khách mời chính", // translated 
  sendVoucherEmail: "Gửi email phiếu giảm giá", // translated 
  sendCancellationEmail: "Gửi email hủy đơn", // translated 
  downloadVoucher: "Tải xuống phiếu giảm giá", // translated 
  emailHasBeenSent: "Email đã được gửi thành công", // translated 
  emailNotSentTryAgain: "Email không được gửi! Vui lòng thử lại.", // translated 
  titleIsRequired: "Tiêu đề là bắt buộc", // translated 
  genderIsRequired: "Cần xác định giới tính.", // translated 
  firstNameMustContainAlphabetic:
    "Tên phải chỉ chứa các ký tự chữ cái.", // translated 
  firstNameIsRequired: "Tên là bắt buộc", // translated 
  lastNameIsRequired: "Cần phải có họ.", // translated 
  lastNameMustContainAlphabetic:
    "Họ phải chỉ chứa các ký tự chữ cái.", // translated 
  phoneNumberInTheFormat: "Số điện thoại phải được nhập đúng định dạng, không có khoảng trắng.", // translated 
  phoneNumberIsRequired: "Cần có số điện thoại.", // translated 
  emailIsRequired: "Cần có email.", // translated 
  invalidEmail: "Email không hợp lệ", // translated 
  addressIsRequired: "Địa chỉ là bắt buộc", // translated 
  cityIsRequired: "Thành phố yêu cầu", // translated 
  postalCodeIsRequired: "Cần có mã bưu chính.", // translated 
  countryIsRequired: "Quốc gia là bắt buộc", // translated 
  yourReservationIsInProgress: "Quá trình đặt chỗ của bạn đang được xử lý.", // translated 
  yourReservationHasBeenRegistered: "Đặt chỗ của bạn đã được đăng ký.", // translated 
  clickHere: "Nhấp vào đây", // translated 
  iHaveReadAgreeWithAbove: "Tôi đã đọc và đồng ý với những điều nêu trên.", // translated 
  pleaseCheckTheBox:
    "Vui lòng đánh dấu vào ô phía dưới để xác nhận rằng bạn đã đọc và đồng ý với thông tin được cung cấp trước khi chuyển sang bước tiếp theo.", // translated 
  pleaseAcceptProperty:
    "Vui lòng đánh dấu vào ô phía trên để xác nhận rằng bạn đang đặt phòng theo yêu cầu của mình.", // translated 
  ourContactNumbersAre: "Số điện thoại liên hệ của chúng tôi là", // translated 
  operationalHours: "Giờ hoạt động", // translated 
  monday: "Thứ hai", // translated 
  tuesday: "Thứ ba", // translated 
  wednesday: "Thứ Tư", // translated 
  thursday: "Thứ năm", // translated 
  friday: "Thứ sáu", // translated 
  saturday: "Thứ bảy", // translated 
  sunday: "Chủ nhật", // translated 
  monday_to_friday: "Thứ Hai đến Thứ Sáu", // translated 
  closed: "Đóng cửa", // translated 
  topUpPoints: "Nạp thêm điểm", // translated 
  gender: "Giới tính", // translated 
  nationality: "Quốc tịch", // translated 
  amountIn: "Số tiền", // translated 
  amountOut: "Số tiền chi ra", // translated 
  maintenanceTitle: "Trang web đang được bảo trì.", // translated 
  maintenanceDescription:
    "Chúng tôi đang tiến hành bảo trì định kỳ. Vui lòng quay lại sau.", // translated 
  maintenanceCountdownLabel: "Thời gian ước tính còn lại", // translated 
  maintenanceLogoAlt: "Logo trang web", // translated 
  maintenanceDays: "Ngày", // translated 
  maintenanceHours: "Giờ", // translated 
  maintenanceMinutes: "Phút", // translated 
  maintenanceSeconds: "Giây", // translated 
  maintenanceStatusBadge: "Bảo trì định kỳ", // translated 
  maintenanceRefresh: "Làm mới trang", // translated 
  maintenanceExpired:
    "Quá trình bảo trì sẽ sớm hoàn tất. Vui lòng làm mới trang.", // translated 
};


export default commonAndMisc;
